/**
 * @fileoverview gRPC-Web generated client stub for trust
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: trust/trust.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var contentstore_contentstore_pb = require('../contentstore/contentstore_pb.js')

var attachment_attachment_pb = require('../attachment/attachment_pb.js')
const proto = {};
proto.trust = require('./trust_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.trust.TrustServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.trust.TrustServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetTrustAccountForParentRequest,
 *   !proto.trust.GetTrustAccountResponse>}
 */
const methodDescriptor_TrustService_GetTrustAccountForParent = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetTrustAccountForParent',
  grpc.web.MethodType.UNARY,
  proto.trust.GetTrustAccountForParentRequest,
  proto.trust.GetTrustAccountResponse,
  /**
   * @param {!proto.trust.GetTrustAccountForParentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetTrustAccountResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetTrustAccountForParentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetTrustAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetTrustAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getTrustAccountForParent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetTrustAccountForParent',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTrustAccountForParent,
      callback);
};


/**
 * @param {!proto.trust.GetTrustAccountForParentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetTrustAccountResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getTrustAccountForParent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetTrustAccountForParent',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTrustAccountForParent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateAssetRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateAsset = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateAsset',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateAssetRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateAssetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateAssetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateAsset =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateAsset',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateAsset,
      callback);
};


/**
 * @param {!proto.trust.UpdateAssetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateAsset =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateAsset',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateAsset);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateCompanyInfoRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateCompanyInfo = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateCompanyInfo',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateCompanyInfoRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateCompanyInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateCompanyInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateCompanyInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateCompanyInfo',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateCompanyInfo,
      callback);
};


/**
 * @param {!proto.trust.UpdateCompanyInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateCompanyInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateCompanyInfo',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateCompanyInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.AddDocumentRequest,
 *   !proto.trust.AddDocumentResponse>}
 */
const methodDescriptor_TrustService_AddDocument = new grpc.web.MethodDescriptor(
  '/trust.TrustService/AddDocument',
  grpc.web.MethodType.UNARY,
  proto.trust.AddDocumentRequest,
  proto.trust.AddDocumentResponse,
  /**
   * @param {!proto.trust.AddDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.AddDocumentResponse.deserializeBinary
);


/**
 * @param {!proto.trust.AddDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.AddDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.AddDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.addDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/AddDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_AddDocument,
      callback);
};


/**
 * @param {!proto.trust.AddDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.AddDocumentResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.addDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/AddDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_AddDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.DeleteDocumentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_DeleteDocument = new grpc.web.MethodDescriptor(
  '/trust.TrustService/DeleteDocument',
  grpc.web.MethodType.UNARY,
  proto.trust.DeleteDocumentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.DeleteDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.DeleteDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.deleteDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/DeleteDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteDocument,
      callback);
};


/**
 * @param {!proto.trust.DeleteDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.deleteDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/DeleteDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateDocumentPrivacyRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateDocumentPrivacy = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateDocumentPrivacy',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateDocumentPrivacyRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateDocumentPrivacyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateDocumentPrivacyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateDocumentPrivacy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateDocumentPrivacy',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateDocumentPrivacy,
      callback);
};


/**
 * @param {!proto.trust.UpdateDocumentPrivacyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateDocumentPrivacy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateDocumentPrivacy',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateDocumentPrivacy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetDocumentsRequest,
 *   !proto.trust.GetDocumentsResponse>}
 */
const methodDescriptor_TrustService_GetDocuments = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetDocuments',
  grpc.web.MethodType.UNARY,
  proto.trust.GetDocumentsRequest,
  proto.trust.GetDocumentsResponse,
  /**
   * @param {!proto.trust.GetDocumentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetDocumentsResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetDocumentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetDocumentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getDocuments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetDocuments',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetDocuments,
      callback);
};


/**
 * @param {!proto.trust.GetDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetDocumentsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getDocuments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetDocuments',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetDocuments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.AddPlatformDocumentRequest,
 *   !proto.trust.AddPlatformDocumentResponse>}
 */
const methodDescriptor_TrustService_AddPlatformDocument = new grpc.web.MethodDescriptor(
  '/trust.TrustService/AddPlatformDocument',
  grpc.web.MethodType.UNARY,
  proto.trust.AddPlatformDocumentRequest,
  proto.trust.AddPlatformDocumentResponse,
  /**
   * @param {!proto.trust.AddPlatformDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.AddPlatformDocumentResponse.deserializeBinary
);


/**
 * @param {!proto.trust.AddPlatformDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.AddPlatformDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.AddPlatformDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.addPlatformDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/AddPlatformDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_AddPlatformDocument,
      callback);
};


/**
 * @param {!proto.trust.AddPlatformDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.AddPlatformDocumentResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.addPlatformDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/AddPlatformDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_AddPlatformDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.DeletePlatformDocumentMetadataRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_DeletePlatformDocumentMetadata = new grpc.web.MethodDescriptor(
  '/trust.TrustService/DeletePlatformDocumentMetadata',
  grpc.web.MethodType.UNARY,
  proto.trust.DeletePlatformDocumentMetadataRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.DeletePlatformDocumentMetadataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.DeletePlatformDocumentMetadataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.deletePlatformDocumentMetadata =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/DeletePlatformDocumentMetadata',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeletePlatformDocumentMetadata,
      callback);
};


/**
 * @param {!proto.trust.DeletePlatformDocumentMetadataRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.deletePlatformDocumentMetadata =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/DeletePlatformDocumentMetadata',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeletePlatformDocumentMetadata);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.RegeneratePlatformDocumentRequest,
 *   !proto.trust.AddPlatformDocumentResponse>}
 */
const methodDescriptor_TrustService_RegeneratePlatformDocument = new grpc.web.MethodDescriptor(
  '/trust.TrustService/RegeneratePlatformDocument',
  grpc.web.MethodType.UNARY,
  proto.trust.RegeneratePlatformDocumentRequest,
  proto.trust.AddPlatformDocumentResponse,
  /**
   * @param {!proto.trust.RegeneratePlatformDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.AddPlatformDocumentResponse.deserializeBinary
);


/**
 * @param {!proto.trust.RegeneratePlatformDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.AddPlatformDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.AddPlatformDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.regeneratePlatformDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/RegeneratePlatformDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_RegeneratePlatformDocument,
      callback);
};


/**
 * @param {!proto.trust.RegeneratePlatformDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.AddPlatformDocumentResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.regeneratePlatformDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/RegeneratePlatformDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_RegeneratePlatformDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.ListOriginsResponse>}
 */
const methodDescriptor_TrustService_ListOrigins = new grpc.web.MethodDescriptor(
  '/trust.TrustService/ListOrigins',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.ListOriginsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.ListOriginsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.ListOriginsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.ListOriginsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.listOrigins =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/ListOrigins',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListOrigins,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.ListOriginsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.listOrigins =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/ListOrigins',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListOrigins);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetPlatformDocumentMetadataRequest,
 *   !proto.trust.GetPlatformDocumentMetadataResponse>}
 */
const methodDescriptor_TrustService_GetPlatformDocumentMetadata = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetPlatformDocumentMetadata',
  grpc.web.MethodType.UNARY,
  proto.trust.GetPlatformDocumentMetadataRequest,
  proto.trust.GetPlatformDocumentMetadataResponse,
  /**
   * @param {!proto.trust.GetPlatformDocumentMetadataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetPlatformDocumentMetadataResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetPlatformDocumentMetadataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetPlatformDocumentMetadataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetPlatformDocumentMetadataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getPlatformDocumentMetadata =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetPlatformDocumentMetadata',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetPlatformDocumentMetadata,
      callback);
};


/**
 * @param {!proto.trust.GetPlatformDocumentMetadataRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetPlatformDocumentMetadataResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getPlatformDocumentMetadata =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetPlatformDocumentMetadata',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetPlatformDocumentMetadata);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GenerateSummaryRequest,
 *   !proto.trust.GenerateSummaryResponse>}
 */
const methodDescriptor_TrustService_GenerateSummary = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GenerateSummary',
  grpc.web.MethodType.UNARY,
  proto.trust.GenerateSummaryRequest,
  proto.trust.GenerateSummaryResponse,
  /**
   * @param {!proto.trust.GenerateSummaryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GenerateSummaryResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GenerateSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GenerateSummaryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GenerateSummaryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.generateSummary =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GenerateSummary',
      request,
      metadata || {},
      methodDescriptor_TrustService_GenerateSummary,
      callback);
};


/**
 * @param {!proto.trust.GenerateSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GenerateSummaryResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.generateSummary =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GenerateSummary',
      request,
      metadata || {},
      methodDescriptor_TrustService_GenerateSummary);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.ListNotificationEmailsResponse>}
 */
const methodDescriptor_TrustService_ListNotificationEmails = new grpc.web.MethodDescriptor(
  '/trust.TrustService/ListNotificationEmails',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.ListNotificationEmailsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.ListNotificationEmailsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.ListNotificationEmailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.ListNotificationEmailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.listNotificationEmails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/ListNotificationEmails',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListNotificationEmails,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.ListNotificationEmailsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.listNotificationEmails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/ListNotificationEmails',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListNotificationEmails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateNotificationEmailsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateNotificationEmails = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateNotificationEmails',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateNotificationEmailsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateNotificationEmailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateNotificationEmailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateNotificationEmails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateNotificationEmails',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateNotificationEmails,
      callback);
};


/**
 * @param {!proto.trust.UpdateNotificationEmailsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateNotificationEmails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateNotificationEmails',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateNotificationEmails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.GetNdaTemplateBlocksResponse>}
 */
const methodDescriptor_TrustService_GetNdaTemplateBlocks = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetNdaTemplateBlocks',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.GetNdaTemplateBlocksResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetNdaTemplateBlocksResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetNdaTemplateBlocksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetNdaTemplateBlocksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getNdaTemplateBlocks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetNdaTemplateBlocks',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetNdaTemplateBlocks,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetNdaTemplateBlocksResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getNdaTemplateBlocks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetNdaTemplateBlocks',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetNdaTemplateBlocks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.InviteUserRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_InviteUser = new grpc.web.MethodDescriptor(
  '/trust.TrustService/InviteUser',
  grpc.web.MethodType.UNARY,
  proto.trust.InviteUserRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.InviteUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.InviteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.inviteUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/InviteUser',
      request,
      metadata || {},
      methodDescriptor_TrustService_InviteUser,
      callback);
};


/**
 * @param {!proto.trust.InviteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.inviteUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/InviteUser',
      request,
      metadata || {},
      methodDescriptor_TrustService_InviteUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.ListUsersRequest,
 *   !proto.trust.ListUsersResponse>}
 */
const methodDescriptor_TrustService_ListUsers = new grpc.web.MethodDescriptor(
  '/trust.TrustService/ListUsers',
  grpc.web.MethodType.UNARY,
  proto.trust.ListUsersRequest,
  proto.trust.ListUsersResponse,
  /**
   * @param {!proto.trust.ListUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.ListUsersResponse.deserializeBinary
);


/**
 * @param {!proto.trust.ListUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.ListUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.ListUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.listUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/ListUsers',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListUsers,
      callback);
};


/**
 * @param {!proto.trust.ListUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.ListUsersResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.listUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/ListUsers',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateUserStatusRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateUserStatus = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateUserStatus',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateUserStatusRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateUserStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateUserStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateUserStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateUserStatus',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateUserStatus,
      callback);
};


/**
 * @param {!proto.trust.UpdateUserStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateUserStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateUserStatus',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateUserStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.AdminExchangeTokenResponse>}
 */
const methodDescriptor_TrustService_AdminExchangeToken = new grpc.web.MethodDescriptor(
  '/trust.TrustService/AdminExchangeToken',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.AdminExchangeTokenResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.AdminExchangeTokenResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.AdminExchangeTokenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.AdminExchangeTokenResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.adminExchangeToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/AdminExchangeToken',
      request,
      metadata || {},
      methodDescriptor_TrustService_AdminExchangeToken,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.AdminExchangeTokenResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.adminExchangeToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/AdminExchangeToken',
      request,
      metadata || {},
      methodDescriptor_TrustService_AdminExchangeToken);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.trust.PublicTrustServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.trust.PublicTrustServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetTrustAccountRequest,
 *   !proto.trust.GetTrustAccountResponse>}
 */
const methodDescriptor_PublicTrustService_GetTrustAccount = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetTrustAccount',
  grpc.web.MethodType.UNARY,
  proto.trust.GetTrustAccountRequest,
  proto.trust.GetTrustAccountResponse,
  /**
   * @param {!proto.trust.GetTrustAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetTrustAccountResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetTrustAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetTrustAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetTrustAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getTrustAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustAccount',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustAccount,
      callback);
};


/**
 * @param {!proto.trust.GetTrustAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetTrustAccountResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getTrustAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustAccount',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetCompanyInfoRequest,
 *   !proto.trust.GetCompanyInfoResponse>}
 */
const methodDescriptor_PublicTrustService_GetCompanyInfo = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetCompanyInfo',
  grpc.web.MethodType.UNARY,
  proto.trust.GetCompanyInfoRequest,
  proto.trust.GetCompanyInfoResponse,
  /**
   * @param {!proto.trust.GetCompanyInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetCompanyInfoResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetCompanyInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetCompanyInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetCompanyInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getCompanyInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetCompanyInfo',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetCompanyInfo,
      callback);
};


/**
 * @param {!proto.trust.GetCompanyInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetCompanyInfoResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getCompanyInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetCompanyInfo',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetCompanyInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetAssetsRequest,
 *   !proto.trust.GetAssetsResponse>}
 */
const methodDescriptor_PublicTrustService_GetAssets = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetAssets',
  grpc.web.MethodType.UNARY,
  proto.trust.GetAssetsRequest,
  proto.trust.GetAssetsResponse,
  /**
   * @param {!proto.trust.GetAssetsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetAssetsResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetAssetsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetAssetsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetAssetsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getAssets =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetAssets',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetAssets,
      callback);
};


/**
 * @param {!proto.trust.GetAssetsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetAssetsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getAssets =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetAssets',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetAssets);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetVisitorDocumentsRequest,
 *   !proto.trust.GetVisitorDocumentsResponse>}
 */
const methodDescriptor_PublicTrustService_GetVisitorDocuments = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetVisitorDocuments',
  grpc.web.MethodType.UNARY,
  proto.trust.GetVisitorDocumentsRequest,
  proto.trust.GetVisitorDocumentsResponse,
  /**
   * @param {!proto.trust.GetVisitorDocumentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetVisitorDocumentsResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetVisitorDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetVisitorDocumentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetVisitorDocumentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getVisitorDocuments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetVisitorDocuments',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetVisitorDocuments,
      callback);
};


/**
 * @param {!proto.trust.GetVisitorDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetVisitorDocumentsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getVisitorDocuments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetVisitorDocuments',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetVisitorDocuments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetTrustDocumentDownloadUrlRequest,
 *   !proto.contentstore.URL>}
 */
const methodDescriptor_PublicTrustService_GetTrustDocumentDownloadUrl = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetTrustDocumentDownloadUrl',
  grpc.web.MethodType.UNARY,
  proto.trust.GetTrustDocumentDownloadUrlRequest,
  contentstore_contentstore_pb.URL,
  /**
   * @param {!proto.trust.GetTrustDocumentDownloadUrlRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  contentstore_contentstore_pb.URL.deserializeBinary
);


/**
 * @param {!proto.trust.GetTrustDocumentDownloadUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.URL)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.URL>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getTrustDocumentDownloadUrl =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustDocumentDownloadUrl',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustDocumentDownloadUrl,
      callback);
};


/**
 * @param {!proto.trust.GetTrustDocumentDownloadUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.URL>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getTrustDocumentDownloadUrl =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustDocumentDownloadUrl',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustDocumentDownloadUrl);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetVisitorAccessGrantRequest,
 *   !proto.trust.GetVisitorAccessGrantResponse>}
 */
const methodDescriptor_PublicTrustService_GetVisitorAccessGrant = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetVisitorAccessGrant',
  grpc.web.MethodType.UNARY,
  proto.trust.GetVisitorAccessGrantRequest,
  proto.trust.GetVisitorAccessGrantResponse,
  /**
   * @param {!proto.trust.GetVisitorAccessGrantRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetVisitorAccessGrantResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetVisitorAccessGrantRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetVisitorAccessGrantResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetVisitorAccessGrantResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getVisitorAccessGrant =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetVisitorAccessGrant',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetVisitorAccessGrant,
      callback);
};


/**
 * @param {!proto.trust.GetVisitorAccessGrantRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetVisitorAccessGrantResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getVisitorAccessGrant =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetVisitorAccessGrant',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetVisitorAccessGrant);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.CreateUpdateAccessGrantRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_PublicTrustService_CreateOrUpdateAccessGrantRequest = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/CreateOrUpdateAccessGrantRequest',
  grpc.web.MethodType.UNARY,
  proto.trust.CreateUpdateAccessGrantRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.CreateUpdateAccessGrantRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.CreateUpdateAccessGrantRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.createOrUpdateAccessGrantRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/CreateOrUpdateAccessGrantRequest',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_CreateOrUpdateAccessGrantRequest,
      callback);
};


/**
 * @param {!proto.trust.CreateUpdateAccessGrantRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.createOrUpdateAccessGrantRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/CreateOrUpdateAccessGrantRequest',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_CreateOrUpdateAccessGrantRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.ExchangeTokenRequest,
 *   !proto.trust.ExchangeTokenResponse>}
 */
const methodDescriptor_PublicTrustService_ExchangeToken = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/ExchangeToken',
  grpc.web.MethodType.UNARY,
  proto.trust.ExchangeTokenRequest,
  proto.trust.ExchangeTokenResponse,
  /**
   * @param {!proto.trust.ExchangeTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.ExchangeTokenResponse.deserializeBinary
);


/**
 * @param {!proto.trust.ExchangeTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.ExchangeTokenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.ExchangeTokenResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.exchangeToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/ExchangeToken',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_ExchangeToken,
      callback);
};


/**
 * @param {!proto.trust.ExchangeTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.ExchangeTokenResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.exchangeToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/ExchangeToken',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_ExchangeToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetTrustDocumentWatermarkedDataRequest,
 *   !proto.trust.GetTrustDocumentWatermarkedDataResponse>}
 */
const methodDescriptor_PublicTrustService_GetTrustDocumentWatermarkedData = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetTrustDocumentWatermarkedData',
  grpc.web.MethodType.UNARY,
  proto.trust.GetTrustDocumentWatermarkedDataRequest,
  proto.trust.GetTrustDocumentWatermarkedDataResponse,
  /**
   * @param {!proto.trust.GetTrustDocumentWatermarkedDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetTrustDocumentWatermarkedDataResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetTrustDocumentWatermarkedDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetTrustDocumentWatermarkedDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetTrustDocumentWatermarkedDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getTrustDocumentWatermarkedData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustDocumentWatermarkedData',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustDocumentWatermarkedData,
      callback);
};


/**
 * @param {!proto.trust.GetTrustDocumentWatermarkedDataRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetTrustDocumentWatermarkedDataResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getTrustDocumentWatermarkedData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustDocumentWatermarkedData',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustDocumentWatermarkedData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetNdaForVisitorRequest,
 *   !proto.trust.GetNdaForVisitorResponse>}
 */
const methodDescriptor_PublicTrustService_GetNdaForVisitor = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetNdaForVisitor',
  grpc.web.MethodType.UNARY,
  proto.trust.GetNdaForVisitorRequest,
  proto.trust.GetNdaForVisitorResponse,
  /**
   * @param {!proto.trust.GetNdaForVisitorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetNdaForVisitorResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetNdaForVisitorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetNdaForVisitorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetNdaForVisitorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getNdaForVisitor =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetNdaForVisitor',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetNdaForVisitor,
      callback);
};


/**
 * @param {!proto.trust.GetNdaForVisitorRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetNdaForVisitorResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getNdaForVisitor =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetNdaForVisitor',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetNdaForVisitor);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.SignNdaForVisitorRequest,
 *   !proto.trust.SignNdaForVisitorResponse>}
 */
const methodDescriptor_PublicTrustService_SignNdaForVisitor = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/SignNdaForVisitor',
  grpc.web.MethodType.UNARY,
  proto.trust.SignNdaForVisitorRequest,
  proto.trust.SignNdaForVisitorResponse,
  /**
   * @param {!proto.trust.SignNdaForVisitorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.SignNdaForVisitorResponse.deserializeBinary
);


/**
 * @param {!proto.trust.SignNdaForVisitorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.SignNdaForVisitorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.SignNdaForVisitorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.signNdaForVisitor =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/SignNdaForVisitor',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_SignNdaForVisitor,
      callback);
};


/**
 * @param {!proto.trust.SignNdaForVisitorRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.SignNdaForVisitorResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.signNdaForVisitor =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/SignNdaForVisitor',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_SignNdaForVisitor);
};


module.exports = proto.trust;

